import type { FabData } from './fab.types';

/**
 * Determines whether the FAB should render on the current page.
 *
 * Rules (per ticket SPARKS-120):
 * - `fabLayout === 'disable'` → never render (explicit hide override)
 * - empty `fabCtas` → don't render (no content even if inherited)
 * - everything else (`'default'` | `''` | undefined) → render if ctas present
 */
export function shouldRenderFab(fab?: Partial<FabData>): boolean {
  if (!fab) return false;
  if (fab.fabLayout === 'disable') return false;
  return (fab.fabCtas?.length ?? 0) > 0;
}

/**
 * Determines whether the FAB's mobile headerCta-Pill should render.
 *
 * Replaces the Header CTA when it's hidden behind the mobile menu.
 * - `'active'` → render if payload (label/link) is present
 * - `'disable'` | `''` | undefined | any other value → don't render
 */
export function shouldRenderFabHeaderCta(fab?: Partial<FabData>): boolean {
  if (!fab) return false;
  if (fab.headerCtaPrimaryState !== 'active') return false;
  const cta = fab.headerCtaPrimary;
  if (!cta) return false;
  return Boolean(cta.linkTitle && cta.linkUrl);
}
